// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const articleActions = require('client-v2/common/models/article/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const { defaultFeedActions } = require('./actions')
const Feed = require('./component-dumb')
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedSmartComponent,
  defaultFeedSmartComponent: createFeedSmartComponent(defaultFeedActions, defaultFeedSelectors)
}

function createFeedSmartComponent(feedActions, feedSelectors) {
  return {
    default: connect(mapStateToProps, mapDispatchToProps)(ImmutableToJS(Feed)),
    mapStateToProps,
    mapDispatchToProps,
    showArticleProfileModal
  }

  function mapStateToProps(state, ownProps) {
    const { user } = state
    return {
      // Flags
      isMoreAvailable: feedSelectors.getIsNextPageAvailable(state),
      // Values
      items: feedSelectors.getDenormalizedItems(state),
      selfUserId: user.loggedIn ? user.id : undefined,
      // Components
      ...mapStateToDesignSystemComponentsProps(state, ownProps)
    }
  }

  function mapDispatchToProps(dispatch) {
    const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
    return {
      onArticleAddClick: dispatchAuthRequiredAction(
        articleActions.handleArticleAddAction,
        authModalActions.showSignup
      ),
      onArticleCardClick: dispatchAction(articleActions.navigateToArticleContent),
      onArticleCountClick: dispatchAction(showArticleProfileModal),
      onArticleDomainClick: dispatchAction(articleActions.navigateToArticleDomainSearch),
      onArticleEmbedDisclose: dispatchAction(articleActions.trackCardView),
      onArticleMoreClick: dispatchAuthRequiredAction(
        articleActions.showArticleActionsModal,
        authModalActions.showSignup
      ),
      onArticlePreviewClick: dispatchAction(showArticleProfileModal),
      onArticleSeen: dispatchAction(articleActions.trackGridView),
      onArticleShareClick: dispatchAction(articleActions.showArticleShareModal),
      onCollectionCardClick: dispatchAction(collectionActions.navigateToCollectionProfile),
      onCollectionPostCountClick: dispatchAction(collectionActions.navigateToCollectionProfilePosts),
      onCollectionShareClick: dispatchAction(collectionActions.showCollectionShareModal),
      onCollectionSubscribeClick: dispatchAuthRequiredAction(
        collectionActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onCollectionSubscriberCountClick: dispatchAction(collectionActions.navigateToCollectionProfileSubscribers),
      onCollectionUserClick: dispatchAction(collectionActions.navigateToCollectionUserProfile),
      onMoreClick: dispatchAction(feedActions.loadMore),
      onUserCardClick: dispatchAction(userActions.navigateToUserProfile),
      onUserFollowClick: dispatchAuthRequiredAction(
        userActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onUserFollowerCountClick: dispatchAction(userActions.navigateToUserProfileFollowers)
    }
  }

  function showArticleProfileModal(options) {
    if (options.event && options.event.altKey) {
      return articleActions.navigateToArticleProfile(options)
    }
    return feedActions.showArticleProfileModal(options)
  }
}

// Design System Project component imports
const ArticleCardV2 = require('client-v2/common/components/cards/v2/article')
const CollectionCardV2 = require('client-v2/common/components/cards/v2/collection')
const UserCardV2 = require('client-v2/common/components/cards/v2/user')

// eslint-disable-next-line complexity
function mapStateToDesignSystemComponentsProps(state, ownProps) {
  const { user } = state
  const articleCardComponent = user.hasRollout('design_system_article_card') && ArticleCardV2
  const collectionCardComponent = user.hasRollout('design_system_collection_card') && CollectionCardV2
  const userCardComponent = user.hasRollout('design_system_user_card') && UserCardV2
  return {
    articleCardComponent: ownProps.articleCardComponent || articleCardComponent,
    collectionCardComponent: ownProps.collectionCardComponent || collectionCardComponent,
    userCardComponent: ownProps.userCardComponent || userCardComponent
  }
}
